import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import FiliaisOuvidoriaFilter from './FiliaisOuvidoriaFilter';
import FiliaisOuvidoriaHeader from './FiliaisOuvidoriaHeader';
import FiliaisOuvidoriaTable from './FiliaisOuvidoriaTable';
import { useFiliaisOuvidoriaListagem, useFiliaisOuvidoriaNavegacao } from '../hooks';

const FiliaisOuvidoriaCard = ({
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true,
}) => {
  const {
    data,
    loading,
    filterLoading,
    deleteLoading,
    showDeleteModal,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    handleCancelarExclusao,
    handleConfirmarExclusao,
    setPaginaAtual,
    setQuantidadePorPagina,
  } = useFiliaisOuvidoriaListagem();

  const { handleAdicionar, handleEditar, handleRowClick } = useFiliaisOuvidoriaNavegacao();

  return (
    <Card>
      <CardBody>
        {showHeader && (
          <FiliaisOuvidoriaHeader
            totalRegistros={totalRegistros}
            onAdicionar={showActions ? handleAdicionar : undefined}
          />
        )}

        {showFilter && (
          <FiliaisOuvidoriaFilter
            loading={filterLoading}
            values={filtrosUI}
            onApply={handleFilterApply}
            onLimpar={handleLimparFiltros}
          />
        )}

        <FiliaisOuvidoriaTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') {
              setQuantidadePorPagina(next.pageSize);
            }

            if (next && typeof next.pageIndex === 'number') {
              setPaginaAtual(next.pageIndex + 1);
            }
          }}
        />

        <ConfirmDeleteModal
          show={showDeleteModal}
          onClose={handleCancelarExclusao}
          onConfirm={handleConfirmarExclusao}
          loading={deleteLoading}
          title="Excluir filial da ouvidoria"
          message="Tem certeza que deseja excluir esta filial da ouvidoria? Esta acao nao pode ser desfeita."
        />
      </CardBody>
    </Card>
  );
};

export default FiliaisOuvidoriaCard;
